export const STATUS_MESSAGES: Record<number, { title: string }> = {
  // 400
  400: { title: 'Bad Request' },
  401: { title: 'Unauthorized' },
  402: { title: 'Payment Required' },
  403: { title: 'Forbidden' },
  404: { title: 'Not Found' },
  405: { title: 'Method Not Allowed' },
  406: { title: 'Not Acceptable' },
  407: { title: 'Proxy Authentication Required' },
  408: { title: 'Request Timeout' },
  409: { title: 'Conflict' },
  410: { title: 'Gone' },
  411: { title: 'Length Required' },
  412: { title: 'Precondition Failed' },
  413: { title: 'Content Too Large' },
  414: { title: 'URI Too Long' },
  415: { title: 'Unsupported Media Type' },
  416: { title: 'Range Not Satisfiable' },
  417: { title: 'Expectation Failed' },
  418: { title: "I'm a teapot" },
  421: { title: 'Misdirected Request' },
  422: { title: 'Unprocessable Content' },
  423: { title: 'Locked' },
  424: { title: 'Failed Dependency' },
  425: { title: 'Too Early' },
  426: { title: 'Upgrade Required' },
  428: { title: 'Precondition Required' },
  429: { title: 'Too Many Requests' },
  431: { title: 'Request Header Fields Too Large' },
  451: { title: 'Unavailable For Legal Reasons' },

  // 500
  500: { title: 'Internal Server Error' },
  501: { title: 'Not Implemented' },
  502: { title: 'Bad Gateway' },
  503: { title: 'Service Unavailable' },
  504: { title: 'Gateway Timeout' },
  505: { title: 'HTTP Version Not Supported' },
  506: { title: 'Variant Also Negotiates' },
  507: { title: 'Insufficient Storage' },
  508: { title: 'Loop Detected' },
  510: { title: 'Not Extended' },
  511: { title: 'Network Authentication Required' }
}
